import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import { withTranslation } from "react-i18next";

const icons = {
  error: <ErrorIcon color="error" fontSize="large" />,
  warning: <WarningIcon color="warning" fontSize="large" />,
  info: <InfoIcon color="info" fontSize="large" />,
};

const ConfirmationDialog = (props) => {
  const {
    message,
    onCancel,
    onConfirm,
    isOpen,
    title,
    variant,
    isLoading,
    isReadOnly = false,
    t,
    // eslint-disable-next-line no-unused-vars, react/prop-types
    tReady,
    ...dialogProps
  } = props;

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        sx: {
          width: "100%",
        },
      }}
      {...dialogProps}
    >
      <DialogTitle display="flex" alignItems="center">
        {icons[variant]}
        <Typography color={variant} sx={{ ml: 2 }} variant="inherit">
          {t(`${title}`)}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography
          key="customized-message"
          color="textPrimary"
          variant="body1"
          sx={{ wordWrap: "break-word" }}
        >
          {t(`${message}`)}
        </Typography>
      </DialogContent>
      {!isReadOnly && (
        <DialogActions sx={{ padding: "12px" }}>
          <Button
            data-testid="cancelButton"
            color="error"
            onClick={onCancel}
            variant="contained"
            disabled={isLoading}
          >
            {t("No")}
          </Button>
          <Button
            data-testid="confirmButton"
            color="success"
            onClick={onConfirm}
            variant="contained"
            disabled={isLoading}
            endIcon={isLoading ? <CircularProgress size={20} /> : null}
          >
            {t("Yes")}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

ConfirmationDialog.defaultProps = {
  title: "",
  message: "",
  isOpen: false,
  isReadOnly: false,
  variant: PropTypes.oneOf(["error", "warning", "info"]),
  t: () => {},
  onCancel: () => {},
  onConfirm: () => {},
};

ConfirmationDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  variant: PropTypes.oneOf(["error", "warning", "info"]),
  isReadOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(ConfirmationDialog);
